function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.5 15a7.5 7.5 0 100-15 7.5 7.5 0 000 15z",
  fill: "#E0E0E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.774 9.008a.495.495 0 01-.013.634l-.065.061-2.75 2.2a.495.495 0 01-.537.053l-.082-.053-2.75-2.2a.495.495 0 01.545-.822l.074.05 2.44 1.951 2.442-1.952a.495.495 0 01.696.078zm-2.935-5.68l.081.053 2.75 2.2a.495.495 0 01-.544.823l-.075-.05-2.44-1.951L5.17 6.354a.495.495 0 01-.683-.71l.064-.063 2.75-2.2a.495.495 0 01.538-.053z",
  fill: "#666",
  fillRule: "nonzero"
}));

var SvgBtnPackup = function SvgBtnPackup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15
  }, props), _ref);
};

export default SvgBtnPackup;